import $ from "jquery";
export default class SubmissionForm {
    static mount(panelCounter) {
        $('.ce-submission').each(function () {
            new SubmissionForm($(this), panelCounter);
        });
    }
    constructor($targetNode, panelCounter) {
        this.$targetNode = $targetNode;
        this.panelCounter = panelCounter;
        this.updateTypeOfParticipantState();
        $(() => {
            $('input[name="type_of_participant"]', this.$targetNode).on('change', () => this.updateTypeOfParticipantState());
            $('input,textarea', this.$targetNode).on('change', function () {
                $('.server-feedback', $(this).parent()).remove();
            });
            $('input,textarea', this.$targetNode).on('input', () => {
                this.customValidation();
            });
            let that = this;
            $('form', $targetNode).each(function () {
                const $form = $(this);
                $form.on('submit', function (event) {
                    const formElem = $form[0];
                    let isValid = that.customValidation() && formElem.checkValidity();
                    if (!isValid) {
                        event.preventDefault();
                        event.stopPropagation();
                        const elements = $('*:invalid:not(fieldset)', $form);
                        if (elements.length > 0) {
                            const offset = $(elements[0]).offset();
                            if (offset) {
                                $('html, body').animate({
                                    scrollTop: offset.top - 200
                                }, 500);
                            }
                        }
                        else {
                            const offset = that.panelCounter.$targetNode.offset();
                            if (offset) {
                                $('html, body').animate({
                                    scrollTop: offset.top - 200
                                }, 500);
                            }
                        }
                    }
                    $form.addClass('was-validated');
                    $form.removeClass('needs-validation');
                });
                if ($form.hasClass('was-validated')) {
                    that.customValidation();
                }
            });
            const $serverErrors = $('.ce-submission .server-feedback');
            if ($serverErrors && $serverErrors.length > 0) {
                const offset = $serverErrors.offset();
                if (offset) {
                    $('html, body').animate({
                        scrollTop: offset.top - 200
                    }, 500);
                }
            }
        });
    }
    customValidation() {
        if (this.panelCounter.count < 12600 || this.panelCounter.count > 16200) {
            this.panelCounter.setInvalid(true);
            return false;
        }
        this.panelCounter.setInvalid(false);
        return true;
    }
    updateRequiredFields(fieldset, isVisible) {
        $('input,textarea', fieldset).each(function () {
            if (!isVisible)
                $(this).removeAttr('required');
            else {
                if ($(this).hasClass('form-required')) {
                    $(this).attr('required', 'required');
                }
            }
        });
    }
    updateTypeOfParticipantState() {
        const $typeOfParticipant = $('input[name="type_of_participant"]:checked', this.$targetNode).val();
        const $fieldsetLegal = $('.ce-submission__fieldset--legal', this.$targetNode);
        const $fieldsetPrivate = $('.ce-submission__fieldset--private', this.$targetNode);
        if ($typeOfParticipant === undefined) {
            $fieldsetLegal.hide();
            $fieldsetPrivate.hide();
            this.updateRequiredFields($fieldsetLegal, false);
            this.updateRequiredFields($fieldsetPrivate, false);
        }
        else if ($typeOfParticipant == 1) {
            $fieldsetLegal.hide();
            $fieldsetPrivate.show();
            this.updateRequiredFields($fieldsetLegal, false);
            this.updateRequiredFields($fieldsetPrivate, true);
        }
        else {
            $fieldsetLegal.show();
            $fieldsetPrivate.hide();
            this.updateRequiredFields($fieldsetLegal, true);
            this.updateRequiredFields($fieldsetPrivate, false);
        }
    }
}
